import { Component, Input } from '@angular/core';

@Component({
  selector: 'ngx-date-formatter',
  template: `{{value | date: 'dd-MM-yyyy'}}`
})
export class DateFormatterComponent {
  @Input() value: Date;
}